import { createAllowedReturnUrlPatterns } from '@lx/quote-tool/lite/shared/utils';
import { COMPANIES, ENVIRONMENT_TYPES } from '@lx/shared/types';
import { OnlineQuoteToolEnvironment } from '../app/types';

export const environment: OnlineQuoteToolEnvironment = {
  API_BASE_PATH: 'https://api-dev.klgintdc.com/api',
  I18N_PATH: 'https://translations-dev.klgintdc.com',
  COMPANY: COMPANIES.KAPLAN,
  LOCALE: 'en-US', // Default value, overridden via URL parameter 'locale'
  RTL_ENABLED: false, // Default value
  production: false,
  environment: ENVIRONMENT_TYPES.development,
  // TODO: On QT Lite SPA master branch these properties are set as optionals,
  // to avoid avoid having to do the work here too, we defined as empty strings for now, but we should fix this in the future.
  PATH_PREFIX: '',
  FLYWIRE_DEPOSITS_RETURN_URL: '',

  /**
   * List of allowed domain patterns for return URLs.
   * Development allows both HTTP and HTTPS for local testing.
   */
  ALLOWED_RETURN_URL_DOMAIN_PATTERNS: createAllowedReturnUrlPatterns(),
  SUPPORTED_COMPANIES: [COMPANIES.KAPLAN, COMPANIES.POSITIVELY_LANGUAGES],
};
